module.exports = __webpack_public_path__ + "img/play-alt.d8911871.svg";